"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseRegisterUrl = exports.baseLiferayUrl = exports.UpdateType = exports.Permission = void 0;
var baseLiferayUrl = exports.baseLiferayUrl = 'https://localhost:8080/o/rest';
var baseRegisterUrl = exports.baseRegisterUrl = 'https://wbmi-dev-api.azure-api.net/insured/user';
var Permission = exports.Permission = {
  BILLING_INFO: 0,
  PAY_BILL: 1,
  POLICY_DOCUMENTS: 2,
  ID_CARDS: 3,
  CLAIM_SUBMISSION: 4,
  PAPERLESS_SETTINGS: 5,
  VIEW_INVOICE: 6,
  USER_PERMISSIONS: 7,
  USER_ACCESS: 8
};
/* const Permission = {
  POLICY_SUMMARY: 'POLICY_SUMMARY',
  PAY_BILL: 'PAY_BILL',
  POLICY_DOCUMENTS: 'POLICY_DOCUMENTS',
  ID_CARDS: 'ID_CARDS',
  CLAIM_SUBMISSION: 'CLAIM_SUBMISSION',
  PAPERLESS_SETTINGS: 'PAPERLESS_SETTINGS',
  NOTIFICATION_SETTINGS: 'NOTIFICATION_SETTINGS',
  USER_PERMISSIONS: 'USER_PERMISSIONS',
}; */

// for updating the user account in parts
var UpdateType = exports.UpdateType = {
  PROFILE: 0,
  NOTIFICATIONS: 1,
  PAPERLESS: 2,
  PASSWORD: 3
};